export const INVALID = Symbol('INVALID');
